// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"f6153a75","361":"7cf97146","387":"2c4dbc85","418":"274278ee","579":"4805bbe9","965":"d14aac8e"}[chunkId] + ".chunk.css";
};